(function () {
  var grid = document.getElementById('gallery-grid');
  if (!grid) return;

  var items = Array.from(grid.querySelectorAll('[data-gallery-item]'));
  var loadMoreWrap = document.getElementById('gallery-load-more');
  var loadBtn = document.getElementById('gallery-load-btn');
  var BATCH = 10;
  var shown = BATCH;

  function updateVisibility() {
    items.forEach(function (item, i) {
      item.style.display = i < shown ? '' : 'none';
    });
    if (loadMoreWrap) {
      loadMoreWrap.style.display = shown < items.length ? 'flex' : 'none';
    }
  }

  if (loadBtn) {
    loadBtn.addEventListener('click', function () {
      shown = Math.min(shown + BATCH, items.length);
      updateVisibility();
    });
  }

  updateVisibility();

  // Lightbox
  var lightbox = document.getElementById('gallery-lightbox');
  var lightboxImg = document.getElementById('gallery-lightbox-img');
  var lightboxClose = document.getElementById('gallery-lightbox-close');
  var lightboxBackdrop = document.getElementById('gallery-lightbox-backdrop');

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lightboxImg) lightboxImg.src = '';
  }

  grid.addEventListener('click', function (e) {
    var card = e.target.closest('[data-gallery-item]');
    if (!card) return;
    var src = card.dataset.src;
    var img = card.querySelector('.gallery-item__img');
    var alt = img ? img.alt : '';
    if (src) openLightbox(src, alt);
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
})();
